import { useEffect, useState } from 'react';
// material
import {
  Container,
  Stack,
  Grid,
  Box,
  IconButton,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Tooltip,
  Chip,
  Typography,
  DialogContentText,
  Button,
  Checkbox,
  Radio,
  TextField,
  InputAdornment,
  FormGroup,
  FormControlLabel
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// components
import CloseIcon from '@mui/icons-material/Close';
import { AiOutlineMinus } from 'react-icons/ai';
import { MdOutlineAdd, MdOutlineMoreHoriz, MdModeEdit } from 'react-icons/md';
import { BiSearch } from 'react-icons/bi';
import BrudCrumbs from '../../components/BreadCrumbs';
import PageTitle from '../../components/PageHeading';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { CommonApiforJourney } from './JourneyApi';
import Loader from '../Global/Loader';
import { StyledIconButton, StyledTableRow } from '../../utils/StyleTable';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '32px',
    fontWeight: 500,
    textTransform: 'uppercase',
    // whiteSpace: 'nowrap',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '32px'
  }
}));

function JourneyConfigureLanding() {
  const navigate = useNavigate();

  const [cardEdit, setCardEdit] = useState(false);
  const [openLoader, setOpenLoader] = useState(false); // loader
  const [loantyperesdata, setLoantyperesdata] = useState(null);
  const [loansubtyperesdata, setLoansubtyperesdata] = useState(null);
  const [employmenttyperesdata, setEmploymenttyperesdata] = useState(null);
  const [employmentsubtyperesdata, setEmploymentsubtyperesdata] = useState(null);
  const [documentresdata, setDocumentresdata] = useState({});
  const [popupDocumentData, setPopupDocumentData] = useState({
    indexNo: null,
    clickedPopUpData: []
  });
  const [doclistAct, setDoclistAct] = useState(null);
  const [loanAllcombineData, setLoanAllcombineData] = useState(null);
  const [employmentAllcombineData, setEmploymentAllcombineData] = useState(null);
  const [mapDocumentData, setMapDocumentData] = useState([]);
  const [mapIndexchippopup, setMapIndexchippopup] = useState(null);
  const [errorStateData, setErrorStateData] = useState({
    errorMessage: null,
    errorPopUp: false
  });
  const [loanTypestate, setLoanTypestate] = useState({
    loanTypeDetails: [
      {
        loanType: {
          companyId: null,
          currentSequence: null,
          defaultSequence: null,
          iconPath: null,
          isActive: false,
          loanCode: null,
          parentLoanDescription: null,
          parentLoanId: null,
          parentLoanName: '',
          loanTypeIcon: null,
          loanTypeIconPreview: null
        },
        loanSubType: [],
        loanTypePopUp: false,
        loanSubTypePopUp: false,
        loanSubTypeChipPopUp: false
      }
    ],
    employmentTypeDetails: [
      {
        employmentType: {
          companyId: null,
          employmentCategoryCode: null,
          employmentCategoryCustomLogo: null,
          employmentCategoryCustomSeq: null,
          employmentCategoryDefaultLogo: null,
          employmentCategoryDefaultSeq: null,
          employmentCategoryDescription: null,
          employmentCategoryId: null,
          employmentCategoryIsActive: null,
          employmentCategoryName: '',
          employmentTypeIcon: null,
          employmentTypeIconPreview: null
        },
        employmentSubType: [],
        employmentTypePopUp: false,
        employmentSubTypePopUp: false,
        employmentSubTypeChipPopUp: false
      }
    ]
  });

  const { LoginData } = useLoginSelector();

  useEffect(() => {
    loantyprapiFire('loanType', '');
    loantyprapiFire('employmentType', '');
  }, []);

  useEffect(() => {
    localStorage.removeItem('mapDocumentData');
    const mapDocument = [];
    if (loanAllcombineData !== null) {
      loanAllcombineData.forEach((loanType, index) => {
        if (employmentAllcombineData !== null) {
          employmentAllcombineData.forEach((employment, empindex) => {
            const obj = {
              loanType,
              employment,
              documentChipPopUp: false,
              documentRequired: [],
              issDocument: false
            };
            mapDocument.push(obj);
          });
        }
      });
      if (mapDocument.length > 0) {
        setMapDocumentData([...mapDocument]);
        setDoclistAct(mapDocument);
        localStorage.setItem('mapDocumentData', mapDocument.length);
      }
    } else {
      setMapDocumentData([]);
    }
  }, [loanAllcombineData, employmentAllcombineData]);

  useEffect(() => {
    if (doclistAct !== null) {
      setTimeout(() => {
        const docData = localStorage.getItem('mapDocumentData');
        if (Number(docData) === doclistAct.length) {
          doclistAct.forEach((item, mapDocumentIndex) => {
            const obj = {
              loanTypeId: item.loanType.loanType.parentLoanId,
              loanSubtypeId: item.loanType.loanId,
              employmentTypeId: item.employment.employmentType.employmentCategoryId,
              employmentSubtypeId: item.employment.employmentSubcategoryId,
              parentRowId: mapDocumentIndex
            };
            loantyprapiFire('documentType', obj);
          });
        }
      }, 500);
    }
  }, [doclistAct]);

  const loantyprapiFire = async (type, condition) => {
    const companyIdObj = {};
    let methodName = '';
    let endapiPath = '';
    const token = LoginData?.jwt;

    if (type === 'loanType') {
      companyIdObj.companyId = LoginData?.companyId;
      methodName = 'POST';
      endapiPath = 'company/parent-loan-masters/list';
    } else if (type === 'loanSubType') {
      if (condition !== null) {
        companyIdObj.companyId = LoginData?.companyId;
        companyIdObj.parentLoanId = condition;
        methodName = 'POST';
        endapiPath = 'company/loan-masters/list';
      }
    } else if (type === 'employmentType') {
      companyIdObj.companyId = LoginData?.companyId;
      methodName = 'POST';
      endapiPath = 'company/parent-emp-types/list';
    } else if (type === 'employmentSubType') {
      if (condition !== null) {
        companyIdObj.companyId = LoginData?.companyId;
        companyIdObj.employmentCategoryId = condition;
        methodName = 'POST';
        endapiPath = 'company/emp-types/list';
      }
    } else if (type === 'documentType') {
      if (Object.keys(condition).length > 0) {
        if (
          condition.loanTypeId !== null &&
          condition.loanSubtypeId !== null &&
          condition.employmentTypeId !== null &&
          condition.employmentSubtypeId !== null &&
          condition.parentRowId !== null
        ) {
          companyIdObj.companyId = LoginData?.companyId;
          companyIdObj.userId = LoginData?.userId;
          companyIdObj.loanTypeId = condition.loanTypeId;
          companyIdObj.loanSubtypeId = condition.loanSubtypeId;
          companyIdObj.employmentTypeId = condition.employmentTypeId;
          companyIdObj.employmentSubtypeId = condition.employmentSubtypeId;
          companyIdObj.parentRowId = condition.parentRowId;
          methodName = 'POST';
          endapiPath = 'journey/mapped-documents';
        }
      }
    } else if (type === 'submitFormData') {
      let count = 0;
      let loanTypeValidate = true;
      let employmentTypeValidate = true;
      loanTypestate.loanTypeDetails.every((mapItem, mapIndex) => {
        if (mapItem.loanType.parentLoanName === '') {
          setErrorStateData({
            errorMessage: 'Select Loan Type',
            errorPopUp: true
          });
          loanTypeValidate = false;
        } else if (mapItem.loanSubType.length === 0) {
          setErrorStateData({
            errorMessage: 'Select Loan Sub Type',
            errorPopUp: true
          });
          loanTypeValidate = false;
        }
        return true;
      });

      loanTypestate.employmentTypeDetails.every((mapItem, mapIndex) => {
        if (mapItem.employmentType.employmentCategoryName === '') {
          setErrorStateData({
            errorMessage: 'Select Employment Type',
            errorPopUp: true
          });
          employmentTypeValidate = false;
        } else if (mapItem.employmentSubType.length === 0) {
          setErrorStateData({
            errorMessage: 'Select Employment Sub Type',
            errorPopUp: true
          });
          employmentTypeValidate = false;
        }
        return true;
      });

      if (loanTypeValidate === true && employmentTypeValidate === true) {
        mapDocumentData.every((mapItem) => {
          if (mapItem.issDocument === false) {
            setErrorStateData({
              errorMessage: 'Select Document',
              errorPopUp: true
            });
            return false;
          }

          if (mapItem.issDocument === true) {
            count += 1;
          }
          return true;
        });
      }

      if (count === mapDocumentData.length) {
        const selectedObj = {
          companyId: LoginData?.companyId,
          userId: LoginData?.userId,
          loanType: [],
          loanSubType: [],
          employmentType: [],
          employmentSubType: []
        };

        mapDocumentData.forEach((mapItem) => {
          if (mapItem.documentRequired.length > 0) {
            if (!selectedObj.loanType.includes(mapItem.loanType.parentLoanId)) {
              selectedObj.loanType.push(mapItem.loanType.parentLoanId);
            }

            if (!selectedObj.loanSubType.includes(mapItem.loanType.loanId)) {
              selectedObj.loanSubType.push(mapItem.loanType.loanId);
            }

            if (!selectedObj.employmentType.includes(mapItem.employment.employmentCategoryId)) {
              selectedObj.employmentType.push(mapItem.employment.employmentCategoryId);
            }

            if (
              !selectedObj.employmentSubType.includes(mapItem.employment.employmentSubcategoryId)
            ) {
              selectedObj.employmentSubType.push(mapItem.employment.employmentSubcategoryId);
            }
          }
        });

        if (
          selectedObj.loanType.length > 0 &&
          selectedObj.loanSubType.length > 0 &&
          selectedObj.employmentType.length > 0 &&
          selectedObj.employmentSubType.length > 0
        ) {
          methodName = 'POST';
          endapiPath = 'journey/landing-page/save-deselected-loan-emp-types';
          loanTypebycompany(type, methodName, endapiPath, JSON.stringify(selectedObj), token, '');
        }
        mapDocumentData.forEach((mapItem, mapIndex) => {
          methodName = 'POST';
          endapiPath = 'journey/landing-page/submit';
          const formData = new FormData();
          formData.append('parentLoanCode', mapItem.loanType.loanType.loanCode);
          formData.append('parentLoanIsActive', mapItem.loanType.loanType.isActive);
          if (
            mapItem.loanType.loanType.loanTypeIcon !== null &&
            mapItem.loanType.loanType.loanTypeIcon !== undefined
          ) {
            formData.append('loanTypeIcon', mapItem.loanType.loanType.loanTypeIcon);
          }
          formData.append('parentLoanId', mapItem.loanType.loanType.parentLoanId);
          formData.append('userId', LoginData?.userId);
          formData.append('companyId', mapItem.loanType.compId);
          formData.append('isActive', mapItem.loanType.isActive);
          formData.append('loanCode', mapItem.loanType.loanCode);
          formData.append('loanId', mapItem.loanType.loanId);
          if (
            mapItem.loanType.loanSubTypeIcon !== null &&
            mapItem.loanType.loanSubTypeIcon !== undefined
          ) {
            formData.append('loanSubTypeIcon', mapItem.loanType.loanSubTypeIcon);
          }
          formData.append(
            'employmentCategoryId',
            mapItem.employment.employmentType.employmentCategoryId
          );
          formData.append(
            'employmentCategoryCode',
            mapItem.employment.employmentType.employmentCategoryCode
          );
          formData.append(
            'employmentCategoryIsActive',
            mapItem.employment.employmentType.employmentCategoryIsActive
          );
          if (
            mapItem.employment.employmentType.employmentTypeIcon !== null &&
            mapItem.employment.employmentType.employmentTypeIcon !== undefined
          ) {
            formData.append(
              'employmentTypeIcon',
              mapItem.employment.employmentType.employmentTypeIcon
            );
          }
          formData.append('employmentSubcategoryId', mapItem.employment.employmentSubcategoryId);
          if (
            mapItem.employment.employmentSubTypeIcon !== null &&
            mapItem.employment.employmentSubTypeIcon !== undefined
          ) {
            formData.append('employmentSubTypeIcon', mapItem.employment.employmentSubTypeIcon);
          }
          formData.append(
            'employmentSubcategoryCode',
            mapItem.employment.employmentSubcategoryCode
          );
          formData.append(
            'employmentSubcategoryIsActive',
            mapItem.employment.employmentSubcategoryIsActive
          );
          loanTypebycompany(type, methodName, endapiPath, formData, token, 'formdata');
          if (mapItem.documentRequired.length > 0) {
            methodName = 'POST';
            endapiPath = 'journey/landing-page/save-document-mapping-config';
            companyIdObj.documentMappingConfigs = [];
            mapItem.documentRequired.forEach((docItemmap, docItemmapIndex) => {
              companyIdObj.companyId = LoginData?.companyId;
              companyIdObj.userId = LoginData?.userId;
              companyIdObj.documentMappingConfigs.push({
                mappId: docItemmap.mappId,
                documentId: docItemmap.documentId,
                mappIsActive: docItemmap.mappIsActive,
                loanTypeId: mapItem.loanType.loanType.parentLoanId,
                loanSubtypeId: mapItem.loanType.loanId,
                employmentTypeId: mapItem.employment.employmentType.employmentCategoryId,
                employmentSubtypeId: mapItem.employment.employmentSubcategoryId
              });
            });
            loanTypebycompany(
              type,
              methodName,
              endapiPath,
              JSON.stringify(companyIdObj),
              token,
              ''
            );
          }
        });
      }
    }

    if (type !== 'submitFormData') {
      loanTypebycompany(type, methodName, endapiPath, JSON.stringify(companyIdObj), token, '');
    }
  };

  const loanTypebycompany = async (type, method, endpoint, credentials, authToken, frmData) => {
    setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success') {
      setOpenLoader(false);
      if (type === 'loanType') {
        setLoantyperesdata(responseData.data.loanMasters);
        const prevData = loanTypestate;
        const loanTypeArray = [];
        let count = 0;
        responseData.data.loanMasters.forEach((item, index) => {
          if (item.isActive) {
            count += 1;
            loanTypeArray.push({
              loanType: {
                companyId: item.companyId,
                currentSequence: item.currentSequence,
                defaultSequence: item.defaultSequence,
                iconPath: item.iconPath,
                isActive: item.isActive,
                loanCode: item.loanCode,
                parentLoanDescription: item.parentLoanDescription,
                parentLoanId: item.parentLoanId,
                parentLoanName: item.parentLoanName,
                loanTypeIcon: null,
                loanTypeIconPreview: item.iconPath
              },
              loanSubType: [],
              loanTypePopUp: false,
              loanSubTypePopUp: false,
              loanSubTypeChipPopUp: false
            });
            loantyprapiFire('loanSubType', item.parentLoanId);
            createArrayData('loanType');
          }
        });

        if (count > 0) {
          prevData.loanTypeDetails = loanTypeArray;
          setLoanTypestate({
            ...loanTypestate,
            prevData
          });
        }
      } else if (type === 'loanSubType') {
        setLoansubtyperesdata(responseData.data.loanTypes);
        const prevData = loanTypestate.loanTypeDetails;
        responseData.data.loanTypes.forEach((item, index) => {
          if (item.isActive) {
            prevData.forEach((subItem) => {
              if (item.parentLoanId === subItem.loanType.parentLoanId) {
                subItem.loanSubType.push({
                  compId: item.compId,
                  currentSequence: item.currentSequence,
                  defaultSequence: item.defaultSequence,
                  iconPath: item.iconPath,
                  isActive: item.isActive,
                  loanCode: item.loanCode,
                  loanDescription: item.loanDescription,
                  loanId: item.loanId,
                  loanName: item.loanName,
                  loanNameToDisplay: item.loanNameToDisplay,
                  loanSubTypeIcon: null,
                  loanSubTypeIconPreview: item.iconPath,
                  parentLoanId: item.parentLoanId
                });
              }
            });
            createArrayData('loanSubType');
          }
        });

        setLoanTypestate({
          ...loanTypestate,
          loanTypeDetails: prevData
        });
      } else if (type === 'employmentType') {
        setEmploymenttyperesdata(responseData.data.empTypes);

        const prevData = loanTypestate;
        const employmentType = [];
        let count = 0;
        responseData.data.empTypes.forEach((item, index) => {
          if (item.employmentCategoryIsActive) {
            count += 1;
            employmentType.push({
              employmentType: {
                companyId: item.companyId,
                employmentCategoryCode: item.employmentCategoryCode,
                employmentCategoryCustomLogo: item.employmentCategoryCustomLogo,
                employmentCategoryCustomSeq: item.employmentCategoryCustomSeq,
                employmentCategoryDefaultLogo: item.employmentCategoryDefaultLogo,
                employmentCategoryDefaultSeq: item.employmentCategoryDefaultSeq,
                employmentCategoryDescription: item.employmentCategoryDescription,
                employmentCategoryId: item.employmentCategoryId,
                employmentCategoryIsActive: item.employmentCategoryIsActive,
                employmentCategoryName: item.employmentCategoryName,
                employmentTypeIcon: null,
                employmentTypeIconPreview: item.employmentCategoryCustomLogo
              },
              employmentSubType: [],
              employmentTypePopUp: false,
              employmentSubTypePopUp: false,
              employmentSubTypeChipPopUp: false
            });
            loantyprapiFire('employmentSubType', item.employmentCategoryId);
            createArrayData('employmentType');
          }
        });

        if (count > 0) {
          prevData.employmentTypeDetails = employmentType;
          setLoanTypestate({
            ...loanTypestate,
            prevData
          });
        }
      } else if (type === 'employmentSubType') {
        setEmploymentsubtyperesdata(responseData.data.subEmpTypes);
        const prevData = loanTypestate.employmentTypeDetails;
        responseData.data.subEmpTypes.forEach((item, index) => {
          if (item.employmentSubcategoryIsActive) {
            prevData.forEach((subItem, subIndex) => {
              if (item.employmentCategoryId === subItem.employmentType.employmentCategoryId) {
                subItem.employmentSubType.push({
                  companyId: item.companyId,
                  employmentCategoryId: item.employmentCategoryId,
                  employmentSubTypeIcon: null,
                  employmentSubTypeIconPreview: item.employmentSubcategoryCustomLogo,
                  employmentSubcategoryCode: item.employmentSubcategoryCode,
                  employmentSubcategoryCustomLogo: item.employmentSubcategoryCustomLogo,
                  employmentSubcategoryCustomSeq: item.employmentSubcategoryCustomSeq,
                  employmentSubcategoryDefaultLogo: item.employmentSubcategoryDefaultLogo,
                  employmentSubcategoryDefaultSeq: item.employmentSubcategoryDefaultSeq,
                  employmentSubcategoryDescription: item.employmentSubcategoryDescription,
                  employmentSubcategoryId: item.employmentSubcategoryId,
                  employmentSubcategoryIsActive: item.employmentSubcategoryIsActive,
                  employmentSubcategoryName: item.employmentSubcategoryName
                });
              }
            });
            createArrayData('employmentSubType');
          }
        });
        setLoanTypestate({
          ...loanTypestate,
          employmentTypeDetails: prevData
        });
      } else if (type === 'documentType') {
        const parentRowIdObj = JSON.parse(credentials);
        const resData = responseData.data.mappedDocuments;
        if (parentRowIdObj.parentRowId !== null && parentRowIdObj.parentRowId !== undefined) {
          if (resData.length > 0) {
            const prevMapDocData = mapDocumentData;
            const prevArray = documentresdata;
            prevArray[parentRowIdObj.parentRowId] = resData;

            resData.forEach((e) => {
              if (
                prevMapDocData[parentRowIdObj.parentRowId].documentRequired.findIndex(
                  (item) => item.mappId === e.mappId
                ) === -1 &&
                e.mappIsActive
              ) {
                prevMapDocData[parentRowIdObj.parentRowId].issDocument = true;
                prevMapDocData[parentRowIdObj.parentRowId].documentRequired.push(e);
              }
            });
            setMapDocumentData([...prevMapDocData]);
            setDocumentresdata(prevArray);
          }
        }
      } else if (type === 'submitFormData') {
        navigate('/journey/configure');
      }
    }
  };

  const handleChangeloantype = (event, responseData, type, index, subindex) => {
    if (type === 'loanType') {
      const prevData = loanTypestate.loanTypeDetails;
      let loanTypeValue = '';
      prevData.every((mapItem) => {
        if (mapItem.loanType.parentLoanName === responseData.parentLoanName) {
          setErrorStateData({
            errorMessage: 'Select another Loan Type',
            errorPopUp: true
          });
          loanTypeValue = '';
        } else {
          loanTypeValue = responseData.parentLoanName;
        }
        return loanTypeValue;
      });

      prevData[index][type] = {
        companyId: responseData.companyId,
        currentSequence: responseData.currentSequence,
        defaultSequence: responseData.defaultSequence,
        iconPath: responseData.iconPath,
        isActive: true,
        loanCode: responseData.loanCode,
        parentLoanDescription: responseData.parentLoanDescription,
        parentLoanId: responseData.parentLoanId,
        parentLoanName: loanTypeValue,
        loanTypeIcon: null,
        loanTypeIconPreview: null
      };
      setLoanTypestate({
        ...loanTypestate,
        loanTypeDetails: prevData
      });
    } else if (type === 'loanSubType') {
      if (subindex !== '') {
        const prevData = loanTypestate.loanTypeDetails;
        const prevCheckedData = loansubtyperesdata;
        if (prevCheckedData[subindex].isActive === true) {
          prevCheckedData[subindex].isActive = false;
          const indexOfObject = prevData[index][type]?.filter(
            (object) => object.loanCode !== prevCheckedData[subindex]?.loanCode
          );
          prevData[index][type] = indexOfObject;
        } else {
          prevCheckedData[subindex].isActive = true;
          prevData[index][type].push({
            compId: responseData.compId,
            currentSequence: responseData.currentSequence,
            defaultSequence: responseData.defaultSequence,
            iconPath: responseData.iconPath,
            isActive: true,
            loanCode: responseData.loanCode,
            loanDescription: responseData.loanDescription,
            loanId: responseData.loanId,
            loanName: responseData.loanName,
            loanNameToDisplay: responseData.loanNameToDisplay,
            parentLoanId: responseData.parentLoanId,
            loanSubTypeIcon: null,
            loanSubTypeIconPreview: null
          });
        }

        setLoansubtyperesdata(prevCheckedData);
        setLoanTypestate({
          ...loanTypestate,
          loanTypeDetails: prevData
        });
      }
    } else if (type === 'employmentType') {
      const prevData = loanTypestate.employmentTypeDetails;

      let employmentTypeValue = '';
      prevData.every((mapItem) => {
        if (mapItem.employmentType.employmentCategoryName === responseData.employmentCategoryName) {
          setErrorStateData({
            errorMessage: 'Select another Employment Type',
            errorPopUp: true
          });
          employmentTypeValue = '';
        } else {
          employmentTypeValue = responseData.employmentCategoryName;
        }
        return employmentTypeValue;
      });

      prevData[index][type] = {
        companyId: responseData.companyId,
        employmentCategoryCode: responseData.employmentCategoryCode,
        employmentCategoryCustomLogo: responseData.employmentCategoryCustomLogo,
        employmentCategoryCustomSeq: responseData.employmentCategoryCustomSeq,
        employmentCategoryDefaultLogo: responseData.employmentCategoryDefaultLogo,
        employmentCategoryDefaultSeq: responseData.employmentCategoryDefaultSeq,
        employmentCategoryDescription: responseData.employmentCategoryDescription,
        employmentCategoryId: responseData.employmentCategoryId,
        employmentCategoryIsActive: true,
        employmentCategoryName: employmentTypeValue,
        employmentTypeIcon: null,
        employmentTypeIconPreview: null
      };
      setLoanTypestate({
        ...loanTypestate,
        employmentTypeDetails: prevData
      });
    } else if (type === 'employmentSubType') {
      if (subindex !== '') {
        const prevData = loanTypestate.employmentTypeDetails;
        const prevCheckedData = employmentsubtyperesdata;
        if (prevCheckedData[subindex].employmentSubcategoryIsActive === true) {
          prevCheckedData[subindex].employmentSubcategoryIsActive = false;
          const indexOfObject = prevData[index][type]?.filter(
            (object) =>
              object.employmentSubcategoryCode !==
              prevCheckedData[subindex]?.employmentSubcategoryCode
          );
          prevData[index][type] = indexOfObject;
        } else {
          prevCheckedData[subindex].employmentSubcategoryIsActive = true;
          if (
            !prevData[index][type].includes(
              prevData[index][type][subindex]?.employmentSubcategoryCode
            )
          ) {
            prevData[index][type].push(responseData);
          }
        }

        setEmploymentsubtyperesdata(prevCheckedData);
        setLoanTypestate({
          ...loanTypestate,
          employmentTypeDetails: prevData
        });
      }
    } else if (type === 'documentRequired') {
      if (subindex !== '') {
        const prevData = mapDocumentData;
        const popupDocumentPrevData = popupDocumentData;

        if (popupDocumentPrevData.clickedPopUpData[subindex].mappIsActive === true) {
          popupDocumentPrevData.clickedPopUpData[subindex].mappIsActive = false;
        } else {
          popupDocumentPrevData.clickedPopUpData[subindex].mappIsActive = true;
        }

        if (
          prevData[index][type].findIndex((object) => object.mappId === responseData.mappId) >= 0
        ) {
          const indexOfObject = prevData[index][type].findIndex(
            (object) => object.mappId === responseData.mappId
          );
          prevData[index][type].splice(indexOfObject, 1);
        } else {
          prevData[index][type].push({
            documentId: responseData.documentId,
            eligibleForOcr: responseData.eligibleForOcr,
            employmentSubtypeId: responseData.employmentSubtypeId,
            employmentTypeId: responseData.employmentTypeId,
            isMandatory: responseData.isMandatory,
            isOcrRequired: responseData.isOcrRequired,
            journeyDocumentMasterEntity: responseData.journeyDocumentMasterEntity,
            loanSubtypeId: responseData.loanSubtypeId,
            loanTypeId: responseData.loanTypeId,
            mappId: responseData.mappId,
            mappIsActive: true
          });
        }

        if (prevData[index][type].length > 0) {
          prevData[index].issDocument = true;
        } else {
          prevData[index].issDocument = false;
        }
        setMapDocumentData([...prevData]);
        setPopupDocumentData({
          indexNo: index,
          clickedPopUpData: popupDocumentPrevData?.clickedPopUpData
        });
      }
    }
  };

  const openCloseChipPopUp = (type, openClose, index) => {
    if (type === 'loanType') {
      const prevData = loanTypestate.loanTypeDetails;
      if (openClose === 'open') {
        prevData[index].loanTypePopUp = true;
      } else {
        prevData[index].loanTypePopUp = false;
      }
      setLoanTypestate({
        ...loanTypestate,
        loanTypeDetails: prevData
      });
    } else if (type === 'loanSubType') {
      const prevData = loanTypestate.loanTypeDetails;
      if (openClose === 'open') {
        prevData[index].loanSubTypePopUp = true;
      } else {
        prevData[index].loanSubTypePopUp = false;
      }
      setLoanTypestate({
        ...loanTypestate,
        loanTypeDetails: prevData
      });
      createArrayData('loanSubType');
    } else if (type === 'loanSubTypeChipPopUp') {
      const prevData = loanTypestate.loanTypeDetails;
      if (openClose === 'open') {
        prevData[index].loanSubTypeChipPopUp = true;
      } else {
        prevData[index].loanSubTypeChipPopUp = false;
      }
      setLoanTypestate({
        ...loanTypestate,
        loanTypeDetails: prevData
      });
    } else if (type === 'employmentType') {
      const prevData = loanTypestate.employmentTypeDetails;
      if (openClose === 'open') {
        prevData[index].employmentTypePopUp = true;
      } else {
        prevData[index].employmentTypePopUp = false;
      }
      setLoanTypestate({
        ...loanTypestate,
        employmentTypeDetails: prevData
      });
    } else if (type === 'employmentSubType') {
      const prevData = loanTypestate.employmentTypeDetails;
      if (openClose === 'open') {
        prevData[index].employmentSubTypePopUp = true;
      } else {
        prevData[index].employmentSubTypePopUp = false;
      }
      setLoanTypestate({
        ...loanTypestate,
        employmentTypeDetails: prevData
      });
      createArrayData('employmentSubType');
    } else if (type === 'employmentSubTypeChipPopUp') {
      const prevData = loanTypestate.employmentTypeDetails;
      if (openClose === 'open') {
        prevData[index].employmentSubTypeChipPopUp = true;
      } else {
        prevData[index].employmentSubTypeChipPopUp = false;
      }
      setLoanTypestate({
        ...loanTypestate,
        employmentTypeDetails: prevData
      });
    } else if (type === 'documentType') {
      const prevData = mapDocumentData;
      setMapIndexchippopup(index);
      if (openClose === 'open') {
        prevData[index].documentChipPopUp = true;
      } else {
        prevData[index].documentChipPopUp = false;
        setMapIndexchippopup(null);
      }
      setMapDocumentData([...prevData]);
    } else if (type === 'documentPopup') {
      setPopupDocumentData({ indexNo: index, clickedPopUpData: documentresdata[index] });
      setCardEdit(true);
    }
  };

  const addmoreloanType = (type) => {
    if (type === 'loanSubType') {
      setLoanTypestate({
        ...loanTypestate,
        loanTypeDetails: [
          ...loanTypestate.loanTypeDetails,
          {
            loanType: {
              companyId: null,
              currentSequence: null,
              defaultSequence: null,
              iconPath: null,
              isActive: false,
              loanCode: null,
              parentLoanDescription: null,
              parentLoanId: null,
              parentLoanName: '',
              loanTypeIcon: null,
              loanTypeIconPreview: null
            },
            loanSubType: [],
            loanTypePopUp: false,
            loanSubTypePopUp: false,
            loanSubTypeChipPopUp: false
          }
        ]
      });
    } else {
      setLoanTypestate({
        ...loanTypestate,
        employmentTypeDetails: [
          ...loanTypestate.employmentTypeDetails,
          {
            employmentType: {
              companyId: null,
              employmentCategoryCode: null,
              employmentCategoryCustomLogo: null,
              employmentCategoryCustomSeq: null,
              employmentCategoryDefaultLogo: null,
              employmentCategoryDefaultSeq: null,
              employmentCategoryDescription: null,
              employmentCategoryId: null,
              employmentCategoryIsActive: null,
              employmentCategoryName: '',
              employmentTypeIcon: null,
              employmentTypeIconPreview: null
            },
            employmentSubType: [],
            employmentTypePopUp: false,
            employmentSubTypePopUp: false,
            employmentSubTypeChipPopUp: false
          }
        ]
      });
    }
  };

  const createArrayData = (type) => {
    if (type === 'loanSubType') {
      const loantypeArray = [];
      const prevData = loanTypestate.loanTypeDetails;
      prevData.forEach((item, key) => {
        item.loanSubType.forEach((loansubdata, ind) => {
          const obj = {
            compId: loansubdata.compId,
            currentSequence: loansubdata.currentSequence,
            defaultSequence: loansubdata.defaultSequence,
            iconPath: loansubdata.iconPath,
            isActive: loansubdata.isActive,
            loanCode: loansubdata.loanCode,
            loanDescription: loansubdata.loanDescription,
            loanId: loansubdata.loanId,
            loanName: loansubdata.loanName,
            loanNameToDisplay: loansubdata.loanNameToDisplay,
            loanSubTypeIcon: loansubdata.loanSubTypeIcon,
            parentLoanId: loansubdata.parentLoanId,
            loanType: {}
          };
          obj.loanType = item.loanType;
          loantypeArray.push(obj);
        });
      });

      if (loantypeArray.length > 0) {
        setLoanAllcombineData(loantypeArray);
      } else {
        setLoanAllcombineData(null);
      }
    } else {
      const employmenttypeArray = [];
      const prevData = loanTypestate.employmentTypeDetails;
      prevData.forEach((item, key) => {
        item.employmentSubType.forEach((employmentsubdata, ind) => {
          const obj = {
            companyId: employmentsubdata.companyId,
            employmentCategoryId: employmentsubdata.employmentCategoryId,
            employmentSubTypeIcon: employmentsubdata.employmentSubTypeIcon,
            employmentSubcategoryCode: employmentsubdata.employmentSubcategoryCode,
            employmentSubcategoryCustomLogo: employmentsubdata.employmentSubcategoryCustomLogo,
            employmentSubcategoryCustomSeq: employmentsubdata.employmentSubcategoryCustomSeq,
            employmentSubcategoryDefaultLogo: employmentsubdata.employmentSubcategoryDefaultLogo,
            employmentSubcategoryDefaultSeq: employmentsubdata.employmentSubcategoryDefaultSeq,
            employmentSubcategoryDescription: employmentsubdata.employmentSubcategoryDescription,
            employmentSubcategoryId: employmentsubdata.employmentSubcategoryId,
            employmentSubcategoryIsActive: employmentsubdata.employmentSubcategoryIsActive,
            employmentSubcategoryName: employmentsubdata.employmentSubcategoryName,
            employmentType: {}
          };
          obj.employmentType = item.employmentType;
          employmenttypeArray.push(obj);
        });
      });
      if (employmenttypeArray.length > 0) {
        setEmploymentAllcombineData(employmenttypeArray);
      } else {
        setEmploymentAllcombineData(null);
      }
    }
  };

  const removeloanType = (index, type) => {
    if (type === 'loanSubType') {
      const prevData = loanTypestate.loanTypeDetails;
      prevData.splice(index, 1);
      setLoanTypestate({ ...loanTypestate, loanTypeDetails: prevData });
    } else {
      const prevData = loanTypestate.employmentTypeDetails;
      prevData.splice(index, 1);
      setLoanTypestate({ ...loanTypestate, employmentTypeDetails: prevData });
    }
    createArrayData(type);
  };

  const uploadIcon = async (event, type, index, subindex) => {
    if (event.target.files[0] !== undefined) {
      if (type === 'loanType') {
        const prevData = loanTypestate.loanTypeDetails;
        prevData[index][type] = {
          companyId: prevData[index][type].companyId,
          currentSequence: prevData[index][type].currentSequence,
          defaultSequence: prevData[index][type].defaultSequence,
          iconPath: prevData[index][type].iconPath,
          isActive: prevData[index][type].isActive,
          loanCode: prevData[index][type].loanCode,
          parentLoanDescription: prevData[index][type].parentLoanDescription,
          parentLoanId: prevData[index][type].parentLoanId,
          parentLoanName: prevData[index][type].parentLoanName,
          loanTypeIcon: event.target.files[0],
          loanTypeIconPreview: URL.createObjectURL(event.target.files[0])
        };
        setLoanTypestate({
          ...loanTypestate,
          loanTypeDetails: prevData
        });
      } else if (type === 'loanSubType') {
        if (subindex !== '') {
          const prevData = loanTypestate.loanTypeDetails;
          prevData[index][type][subindex] = {
            compId: prevData[index][type][subindex].compId,
            currentSequence: prevData[index][type][subindex].currentSequence,
            defaultSequence: prevData[index][type][subindex].defaultSequence,
            iconPath: prevData[index][type][subindex].iconPath,
            isActive: prevData[index][type][subindex].isActive,
            loanCode: prevData[index][type][subindex].loanCode,
            loanDescription: prevData[index][type][subindex].loanDescription,
            loanId: prevData[index][type][subindex].loanId,
            loanName: prevData[index][type][subindex].loanName,
            loanNameToDisplay: prevData[index][type][subindex].loanNameToDisplay,
            parentLoanId: prevData[index][type][subindex].parentLoanId,
            loanSubTypeIcon: event.target.files[0],
            loanSubTypeIconPreview: URL.createObjectURL(event.target.files[0])
          };
          setLoanTypestate({
            ...loanTypestate,
            loanTypeDetails: prevData
          });
        }
      } else if (type === 'employmentType') {
        const prevData = loanTypestate.employmentTypeDetails;
        prevData[index][type] = {
          companyId: prevData[index][type].companyId,
          employmentCategoryCode: prevData[index][type].employmentCategoryCode,
          employmentCategoryCustomLogo: prevData[index][type].employmentCategoryCustomLogo,
          employmentCategoryCustomSeq: prevData[index][type].employmentCategoryCustomSeq,
          employmentCategoryDefaultLogo: prevData[index][type].employmentCategoryDefaultLogo,
          employmentCategoryDefaultSeq: prevData[index][type].employmentCategoryDefaultSeq,
          employmentCategoryDescription: prevData[index][type].employmentCategoryDescription,
          employmentCategoryId: prevData[index][type].employmentCategoryId,
          employmentCategoryIsActive: prevData[index][type].employmentCategoryIsActive,
          employmentCategoryName: prevData[index][type].employmentCategoryName,
          employmentTypeIcon: event.target.files[0],
          employmentTypeIconPreview: URL.createObjectURL(event.target.files[0])
        };
        setLoanTypestate({
          ...loanTypestate,
          employmentTypeDetails: prevData
        });
      } else if (type === 'employmentSubType') {
        if (subindex !== '') {
          const prevData = loanTypestate.employmentTypeDetails;
          prevData[index][type][subindex] = {
            companyId: prevData[index][type][subindex].companyId,
            employmentCategoryId: prevData[index][type][subindex].employmentCategoryId,
            employmentSubcategoryCode: prevData[index][type][subindex].employmentSubcategoryCode,
            employmentSubcategoryCustomLogo:
              prevData[index][type][subindex].employmentSubcategoryCustomLogo,
            employmentSubcategoryCustomSeq:
              prevData[index][type][subindex].employmentSubcategoryCustomSeq,
            employmentSubcategoryDefaultLogo:
              prevData[index][type][subindex].employmentSubcategoryDefaultLogo,
            employmentSubcategoryDefaultSeq:
              prevData[index][type][subindex].employmentSubcategoryDefaultSeq,
            employmentSubcategoryDescription:
              prevData[index][type][subindex].employmentSubcategoryDescription,
            employmentSubcategoryId: prevData[index][type][subindex].employmentSubcategoryId,
            employmentSubcategoryIsActive:
              prevData[index][type][subindex].employmentSubcategoryIsActive,
            employmentSubcategoryName: prevData[index][type][subindex].employmentSubcategoryName,
            employmentSubTypeIcon: event.target.files[0],
            employmentSubTypeIconPreview: URL.createObjectURL(event.target.files[0])
          };
          setLoanTypestate({
            ...loanTypestate,
            employmentTypeDetails: prevData
          });
        }
      }
    }
  };

  const closePopUp = () => {
    setErrorStateData({
      errorMessage: null,
      errorPopUp: false
    });
  };

  return (
    <Page title="Partner Management System || Journey">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Landing Page" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <Typography variant="body1" className="headingLineUp headingLineUpOut">
            Loan Type Details
          </Typography>
          <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
            <Grid container spacing={2} mb={2} alignItems="end">
              <Grid item xs="4">
                <Box className="">
                  <Typography variant="h6" className="formLabel mar_b_0">
                    Loan Type
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box className="">
                  <Typography variant="h6" className="formLabel mar_b_0">
                    Loan Sub Type
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            {loanTypestate.loanTypeDetails.map((item, loanindex) => (
              <Grid container spacing={2} mb={2} alignItems="end" key={item.loanTypeId}>
                <Grid item xs="4">
                  <Box className="">
                    <Box sx={{ position: 'relative' }}>
                      <TextField
                        fullWidth
                        inputProps={{
                          className: 'textInput',
                          readOnly: true
                        }}
                        value={loanTypestate.loanTypeDetails[loanindex]?.loanType?.parentLoanName}
                        placeholder="Loan Type"
                      />

                      <Tooltip title="Edit" placement="top" arrow>
                        <StyledIconButton
                          className="actionButton searchIconB"
                          onClick={() => {
                            loanTypestate.loanTypeDetails[loanindex].loanSubType = [];
                            openCloseChipPopUp('loanType', 'open', loanindex);
                          }}
                        >
                          <BiSearch size={18} />
                        </StyledIconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                  {/* loan type pop up start */}
                  <Dialog
                    fullWidth
                    className="PopupBox"
                    open={loanTypestate.loanTypeDetails[loanindex].loanTypePopUp}
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Select Loan Type</Typography>
                      <IconButton
                        onClick={() => openCloseChipPopUp('loanType', 'close', loanindex)}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Box mb={2}>
                        <TextField
                          fullWidth
                          placeholder="Search"
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box
                                  component={Icon}
                                  icon={searchFill}
                                  sx={{ color: 'text.disabled' }}
                                />
                              </InputAdornment>
                            )
                          }}
                        />
                      </Box>
                      <Box className="outerTableBox">
                        <Scrollbar>
                          <TableContainer
                            sx={{ height: '250px', overflow: 'auto', background: '' }}
                          >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell />
                                  <StyledTableCell align="">Loan Type</StyledTableCell>
                                  <StyledTableCell align="" width={60}>
                                    Icon
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {loantyperesdata !== null &&
                                  loantyperesdata.map((item, index) => (
                                    <StyledTableRow key={item.loanTypeId}>
                                      <StyledTableCell padding="checkbox">
                                        <Radio
                                          checked={
                                            loanTypestate.loanTypeDetails[loanindex]?.loanType
                                              ?.parentLoanName === item.parentLoanName
                                          }
                                          onClick={(event) =>
                                            handleChangeloantype(
                                              event,
                                              item,
                                              'loanType',
                                              loanindex,
                                              ''
                                            )
                                          }
                                          name="Loan"
                                          inputProps={{ 'aria-label': 'A' }}
                                          size="small"
                                          sx={{ padding: '0' }}
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        {item.parentLoanName}
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        <Tooltip
                                          title={
                                            loanTypestate.loanTypeDetails[loanindex]?.loanType
                                              ?.loanTypeIconPreview !== null ? (
                                              <img
                                                src={
                                                  loanTypestate.loanTypeDetails[loanindex]?.loanType
                                                    ?.loanTypeIconPreview
                                                }
                                                alt=""
                                                width={100}
                                              />
                                            ) : (
                                              <MdModeEdit size={24} />
                                            )
                                          }
                                          size=""
                                          placement="top"
                                          arrow
                                        >
                                          <StyledIconButton
                                            disabled={
                                              loanTypestate.loanTypeDetails[loanindex]?.loanType
                                                ?.parentLoanName !== item.parentLoanName
                                            }
                                            className="squareIconButton actionButton"
                                          >
                                            <input
                                              accept="image/png, image/gif, image/jpeg"
                                              className="fileInput"
                                              id={`loanType_${loanindex}_${item.parentLoanName}`}
                                              multiple
                                              type="file"
                                              onChange={(event) =>
                                                uploadIcon(event, 'loanType', loanindex, '')
                                              }
                                            />
                                            <label
                                              htmlFor={`loanType_${loanindex}_${item.parentLoanName}`}
                                              style={{ height: '15px', lineHeight: '15px' }}
                                            >
                                              <MdModeEdit size={14} />
                                            </label>
                                          </StyledIconButton>
                                        </Tooltip>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() => openCloseChipPopUp('loanType', 'close', loanindex)}
                        variant="contained"
                        className="mainBtn"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* loan type pop up end */}
                </Grid>
                <Grid item xs={4}>
                  <Box className="">
                    <Stack
                      direction="row"
                      spacing={1}
                      className="chipBox"
                      style={{ minHeight: '37px' }}
                    >
                      {loanTypestate.loanTypeDetails[loanindex]?.loanSubType
                        .slice(0, 2)
                        .map((item, index) => (
                          <Chip label={item.loanName} size="small" />
                        ))}

                      <IconButton
                        sx={{ padding: '0' }}
                        size="small"
                        variant="subtitle2"
                        onClick={() =>
                          openCloseChipPopUp('loanSubTypeChipPopUp', 'open', loanindex)
                        }
                      >
                        <MdOutlineMoreHoriz size={16} />
                      </IconButton>
                      <Tooltip title="Edit" placement="top" arrow>
                        <StyledIconButton
                          className="actionButton searchIconB"
                          onClick={() => {
                            loanTypestate.loanTypeDetails[loanindex].loanSubType = [];
                            if (
                              loanTypestate.loanTypeDetails[loanindex].loanType.parentLoanName !==
                              ''
                            ) {
                              loantyprapiFire(
                                'loanSubType',
                                loanTypestate.loanTypeDetails[loanindex].loanType.parentLoanId
                              );
                              openCloseChipPopUp('loanSubType', 'open', loanindex);
                            } else {
                              setErrorStateData({
                                errorMessage: 'Select Loan Type First',
                                errorPopUp: true
                              });
                            }
                          }}
                        >
                          <BiSearch size={18} />
                        </StyledIconButton>
                      </Tooltip>
                    </Stack>
                  </Box>
                  {/* loan sub type pop up start */}
                  <Dialog
                    fullWidth
                    className="PopupBox"
                    open={loanTypestate.loanTypeDetails[loanindex].loanSubTypePopUp}
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Select Loan Sub Type</Typography>
                      <IconButton
                        onClick={() => openCloseChipPopUp('loanSubType', 'close', loanindex)}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Box mb={2}>
                        <TextField
                          fullWidth
                          placeholder="Search"
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box
                                  component={Icon}
                                  icon={searchFill}
                                  sx={{ color: 'text.disabled' }}
                                />
                              </InputAdornment>
                            )
                          }}
                        />
                      </Box>
                      <Box className="outerTableBox">
                        <Scrollbar>
                          <TableContainer
                            sx={{ height: '250px', overflow: 'auto', background: '' }}
                          >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell />
                                  <StyledTableCell align="">Loan Sub Type</StyledTableCell>
                                  <StyledTableCell align="" width={60}>
                                    Icon
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {loansubtyperesdata !== null &&
                                  loansubtyperesdata !== undefined &&
                                  loansubtyperesdata?.map((item, index) => (
                                    <StyledTableRow key={item.loanSubtypeId}>
                                      <StyledTableCell padding="checkbox">
                                        <Checkbox
                                          checked={item.isActive}
                                          onClick={(event) =>
                                            handleChangeloantype(
                                              event,
                                              item,
                                              'loanSubType',
                                              loanindex,
                                              index
                                            )
                                          }
                                          size="small"
                                          sx={{ padding: '0' }}
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align="">{item.loanName}</StyledTableCell>
                                      <StyledTableCell align="">
                                        <Tooltip
                                          title={
                                            loanTypestate.loanTypeDetails[loanindex].loanSubType
                                              .loanSubTypeIconPreview !== null ? (
                                              <img
                                                src={
                                                  loanTypestate.loanTypeDetails[loanindex]
                                                    ?.loanSubType[index]?.loanSubTypeIconPreview
                                                }
                                                alt=""
                                                width={100}
                                              />
                                            ) : (
                                              <MdModeEdit size={24} />
                                            )
                                          }
                                          size=""
                                          placement="top"
                                          arrow
                                        >
                                          <StyledIconButton
                                            className="squareIconButton actionButton"
                                            disabled={!item.isActive}
                                          >
                                            <input
                                              accept="image/png, image/gif, image/jpeg"
                                              className="fileInput"
                                              id={`loanSubType_${loanindex}_${item.loanName}`}
                                              multiple
                                              type="file"
                                              onChange={(event) =>
                                                uploadIcon(event, 'loanSubType', loanindex, index)
                                              }
                                            />
                                            <label
                                              htmlFor={`loanSubType_${loanindex}_${item.loanName}`}
                                              style={{ height: '15px', lineHeight: '15px' }}
                                            >
                                              <MdModeEdit size={14} />
                                            </label>
                                          </StyledIconButton>
                                        </Tooltip>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={(e) => {
                          createArrayData('loanSubType');
                          openCloseChipPopUp('loanSubType', 'close', loanindex);
                        }}
                        variant="contained"
                        className="mainBtn"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* loan sub type pop up end */}
                  {/* all chip pop up start */}
                  <Dialog
                    className="PopupBox"
                    open={loanTypestate.loanTypeDetails[loanindex].loanSubTypeChipPopUp}
                    fullWidth
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6" />
                      <IconButton
                        onClick={() =>
                          openCloseChipPopUp('loanSubTypeChipPopUp', 'close', loanindex)
                        }
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Stack direction="row" sx={{ flexWrap: 'wrap' }} spacing={1}>
                        {loanTypestate.loanTypeDetails[loanindex].loanSubType.map((item, index) => (
                          <Chip
                            key={item.loanSubtypeId}
                            label={item.loanName}
                            sx={{ marginBottom: '0.5rem' }}
                            size="small"
                          />
                        ))}
                      </Stack>
                    </DialogContent>
                  </Dialog>
                  {/* all chip details pop up end */}
                </Grid>
                {loanindex > 0 ? (
                  <Grid item xs="auto">
                    <Tooltip title="Remove" placement="top" arrow>
                      <IconButton
                        onClick={() => removeloanType(loanindex, 'loanSubType')}
                        className="squareIconButton"
                        sx={{ marginBottom: '4px' }}
                      >
                        <AiOutlineMinus size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                ) : (
                  <Grid item xs="auto">
                    <Tooltip title="Add" placement="top" arrow>
                      <IconButton
                        onClick={() => addmoreloanType('loanSubType')}
                        className="squareIconButton"
                        sx={{ marginBottom: '4px' }}
                      >
                        <MdOutlineAdd size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
              </Grid>
            ))}
          </Box>

          <Typography variant="body1" className="headingLineUp headingLineUpOut">
            Employment Type Details
          </Typography>
          <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
            <Grid container spacing={2} mb={2} alignItems="end">
              <Grid item xs="4">
                <Box className="">
                  <Typography variant="h6" className="formLabel mar_b_0">
                    Employment Type
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box className="">
                  <Typography variant="h6" className="formLabel mar_b_0">
                    Employment Sub Type
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            {loanTypestate.employmentTypeDetails.map((item, employmentindex) => (
              <Grid container spacing={2} mb={2} alignItems="end" key={item.employmentTypeId}>
                <Grid item xs={4}>
                  <Box className="">
                    <Box sx={{ position: 'relative' }}>
                      <TextField
                        fullWidth
                        inputProps={{
                          className: 'textInput',
                          readOnly: true
                        }}
                        value={
                          loanTypestate.employmentTypeDetails[employmentindex].employmentType
                            .employmentCategoryName
                        }
                        placeholder="Employment Type"
                      />
                      <Tooltip title="Edit" placement="top" arrow>
                        <StyledIconButton
                          className="actionButton searchIconB"
                          onClick={() => {
                            loanTypestate.employmentTypeDetails[employmentindex].employmentSubType =
                              [];
                            openCloseChipPopUp('employmentType', 'open', employmentindex);
                          }}
                        >
                          <BiSearch size={18} />
                        </StyledIconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                  {/* employment type pop up start */}
                  <Dialog
                    fullWidth
                    className="PopupBox"
                    open={loanTypestate.employmentTypeDetails[employmentindex].employmentTypePopUp}
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Select Employment Type</Typography>
                      <IconButton
                        onClick={() => {
                          loanTypestate.employmentTypeDetails[employmentindex].employmentSubType =
                            [];
                          openCloseChipPopUp('employmentType', 'close', employmentindex);
                        }}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Box mb={2}>
                        <TextField
                          fullWidth
                          placeholder="Search"
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box
                                  component={Icon}
                                  icon={searchFill}
                                  sx={{ color: 'text.disabled' }}
                                />
                              </InputAdornment>
                            )
                          }}
                        />
                      </Box>
                      <Box className="outerTableBox">
                        <Scrollbar>
                          <TableContainer
                            sx={{ height: '250px', overflow: 'auto', background: '' }}
                          >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell />
                                  <StyledTableCell align="">Employment Type</StyledTableCell>
                                  <StyledTableCell align="" width={60}>
                                    Icon
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {employmenttyperesdata !== null &&
                                  employmenttyperesdata.map((item, index) => (
                                    <StyledTableRow key={item.employmentTypeId}>
                                      <StyledTableCell padding="checkbox">
                                        <Radio
                                          checked={
                                            loanTypestate.employmentTypeDetails[employmentindex]
                                              .employmentType.employmentCategoryName ===
                                            item.employmentCategoryName
                                          }
                                          onClick={(event) =>
                                            handleChangeloantype(
                                              event,
                                              item,
                                              'employmentType',
                                              employmentindex,
                                              ''
                                            )
                                          }
                                          name="emptype"
                                          inputProps={{ 'aria-label': 'A' }}
                                          size="small"
                                          sx={{ padding: '0' }}
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        {item.employmentCategoryName}
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        <Tooltip
                                          title={
                                            loanTypestate.employmentTypeDetails[employmentindex]
                                              .employmentType.employmentTypeIconPreview !== null ? (
                                              <img
                                                src={
                                                  loanTypestate.employmentTypeDetails[
                                                    employmentindex
                                                  ].employmentType.employmentTypeIconPreview
                                                }
                                                alt=""
                                                width={100}
                                              />
                                            ) : (
                                              <MdModeEdit size={24} />
                                            )
                                          }
                                          size=""
                                          placement="top"
                                          arrow
                                        >
                                          <StyledIconButton
                                            className="squareIconButton actionButton"
                                            disabled={
                                              loanTypestate.employmentTypeDetails[employmentindex]
                                                .employmentType.employmentCategoryName !==
                                              item.employmentCategoryName
                                            }
                                          >
                                            <input
                                              accept="image/png, image/gif, image/jpeg"
                                              className="fileInput"
                                              id={`employmentType_${employmentindex}_${item.employmentCategoryName}`}
                                              multiple
                                              type="file"
                                              onChange={(event) =>
                                                uploadIcon(
                                                  event,
                                                  'employmentType',
                                                  employmentindex,
                                                  ''
                                                )
                                              }
                                            />
                                            <label
                                              htmlFor={`employmentType_${employmentindex}_${item.employmentCategoryName}`}
                                              style={{ height: '15px', lineHeight: '15px' }}
                                            >
                                              <MdModeEdit size={14} />
                                            </label>
                                          </StyledIconButton>
                                        </Tooltip>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={() =>
                          openCloseChipPopUp('employmentType', 'close', employmentindex)
                        }
                        variant="contained"
                        className="mainBtn"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* employment type pop up end */}
                </Grid>
                <Grid item xs={4}>
                  <Box className="">
                    <Stack
                      direction="row"
                      spacing={1}
                      className="chipBox"
                      style={{ minHeight: '37px' }}
                    >
                      {loanTypestate.employmentTypeDetails[employmentindex].employmentSubType
                        .length > 0 ? (
                        <>
                          {loanTypestate.employmentTypeDetails[employmentindex].employmentSubType
                            .slice(0, 2)
                            .map((item, index) => (
                              <Chip
                                label={item.employmentSubcategoryName}
                                key={index}
                                size="small"
                              />
                            ))}
                        </>
                      ) : (
                        ''
                      )}

                      <IconButton
                        sx={{ padding: '0' }}
                        size="small"
                        variant="subtitle2"
                        onClick={() =>
                          openCloseChipPopUp('employmentSubTypeChipPopUp', 'open', employmentindex)
                        }
                      >
                        <MdOutlineMoreHoriz size={16} />
                      </IconButton>
                      <Tooltip title="Edit" placement="top" arrow>
                        <StyledIconButton
                          className="actionButton searchIconB"
                          onClick={() => {
                            loanTypestate.employmentTypeDetails[employmentindex].employmentSubType =
                              [];
                            if (
                              loanTypestate.employmentTypeDetails[employmentindex].employmentType
                                .employmentCategoryName !== ''
                            ) {
                              loantyprapiFire(
                                'employmentSubType',
                                loanTypestate.employmentTypeDetails[employmentindex].employmentType
                                  .employmentCategoryId
                              );
                              openCloseChipPopUp('employmentSubType', 'open', employmentindex);
                            } else {
                              setErrorStateData({
                                errorMessage: 'Select Employment Type First',
                                errorPopUp: true
                              });
                            }
                          }}
                        >
                          <BiSearch size={18} />
                        </StyledIconButton>
                      </Tooltip>
                    </Stack>
                  </Box>
                  {/* employment sub type pop up start */}
                  <Dialog
                    fullWidth
                    className="PopupBox"
                    open={
                      loanTypestate.employmentTypeDetails[employmentindex].employmentSubTypePopUp
                    }
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Select Employment Sub Type</Typography>
                      <IconButton
                        onClick={() =>
                          openCloseChipPopUp('employmentSubType', 'close', employmentindex)
                        }
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Box mb={2}>
                        <TextField
                          fullWidth
                          placeholder="Search"
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box
                                  component={Icon}
                                  icon={searchFill}
                                  sx={{ color: 'text.disabled' }}
                                />
                              </InputAdornment>
                            )
                          }}
                        />
                      </Box>
                      <Box className="outerTableBox">
                        <Scrollbar>
                          <TableContainer
                            sx={{ height: '250px', overflow: 'auto', background: '' }}
                          >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell />
                                  <StyledTableCell align="">Employment Sub Type</StyledTableCell>
                                  <StyledTableCell align="" width={60}>
                                    Icon
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {employmentsubtyperesdata !== null &&
                                  employmentsubtyperesdata !== undefined &&
                                  employmentsubtyperesdata.map((item, index) => (
                                    <StyledTableRow key={item.employmentSubtypeId}>
                                      <StyledTableCell padding="checkbox">
                                        <Checkbox
                                          checked={item.employmentSubcategoryIsActive}
                                          onClick={(event) =>
                                            handleChangeloantype(
                                              event,
                                              item,
                                              'employmentSubType',
                                              employmentindex,
                                              index
                                            )
                                          }
                                          size="small"
                                          sx={{ padding: '0' }}
                                        />
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        {item.employmentSubcategoryName}
                                      </StyledTableCell>
                                      <StyledTableCell align="">
                                        <Tooltip
                                          title={
                                            loanTypestate.employmentTypeDetails[employmentindex]
                                              .employmentSubType.employmentSubTypeIconPreview !==
                                            null ? (
                                              <img
                                                src={
                                                  loanTypestate.employmentTypeDetails[
                                                    employmentindex
                                                  ]?.employmentSubType[index]
                                                    ?.employmentSubTypeIconPreview
                                                }
                                                alt=""
                                                width={100}
                                              />
                                            ) : (
                                              <MdModeEdit size={24} />
                                            )
                                          }
                                          size=""
                                          placement="top"
                                          arrow
                                        >
                                          <StyledIconButton
                                            className="squareIconButton actionButton"
                                            disabled={!item.employmentSubcategoryIsActive}
                                          >
                                            <input
                                              accept="image/png, image/gif, image/jpeg"
                                              className="fileInput"
                                              id={`employmentSubType_${employmentindex}_${item.employmentSubcategoryName}`}
                                              multiple
                                              type="file"
                                              onChange={(event) =>
                                                uploadIcon(
                                                  event,
                                                  'employmentSubType',
                                                  employmentindex,
                                                  index
                                                )
                                              }
                                            />
                                            <label
                                              htmlFor={`employmentSubType_${employmentindex}_${item.employmentSubcategoryName}`}
                                              style={{ height: '15px', lineHeight: '15px' }}
                                            >
                                              <MdModeEdit size={14} />
                                            </label>
                                          </StyledIconButton>
                                        </Tooltip>
                                      </StyledTableCell>
                                    </StyledTableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={(e) => {
                          createArrayData('employmentSubType');
                          openCloseChipPopUp('employmentSubType', 'close', employmentindex);
                        }}
                        variant="contained"
                        className="mainBtn"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* employment sub type pop up end */}
                  {/* all chip pop up start */}
                  <Dialog
                    className="PopupBox"
                    open={
                      loanTypestate.employmentTypeDetails[employmentindex]
                        .employmentSubTypeChipPopUp
                    }
                    fullWidth
                  >
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6" />
                      <IconButton
                        onClick={() =>
                          openCloseChipPopUp('employmentSubTypeChipPopUp', 'close', employmentindex)
                        }
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <Stack direction="row" sx={{ flexWrap: 'wrap' }} spacing={1}>
                        {loanTypestate.employmentTypeDetails[employmentindex].employmentSubType.map(
                          (item, index) => (
                            <Chip
                              key={index}
                              label={item.employmentSubcategoryName}
                              sx={{ marginBottom: '0.5rem' }}
                              size="small"
                            />
                          )
                        )}
                      </Stack>
                    </DialogContent>
                  </Dialog>
                  {/* all chip details pop up end */}
                </Grid>
                {employmentindex > 0 ? (
                  <Grid item xs="auto">
                    <Tooltip title="Remove" placement="top" arrow>
                      <IconButton
                        onClick={() => removeloanType(employmentindex, 'employmentSubType')}
                        className="squareIconButton"
                        sx={{ marginBottom: '4px' }}
                      >
                        <AiOutlineMinus size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                ) : (
                  <Grid item xs="auto">
                    <Tooltip title="Add" placement="top" arrow>
                      <IconButton
                        onClick={() => addmoreloanType('employmentSubType')}
                        className="squareIconButton"
                        sx={{ marginBottom: '4px' }}
                      >
                        <MdOutlineAdd size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
              </Grid>
            ))}
          </Box>

          {mapDocumentData.length > 0 ? (
            <>
              <Typography variant="body1" className="headingLineUp headingLineUpOut">
                Map Document
              </Typography>
              <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
                <Box className="tableBox outerTableBox">
                  <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: '' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Loan Type</StyledTableCell>
                          <StyledTableCell align="">Loan Sub Type</StyledTableCell>
                          <StyledTableCell align="">Employment Type</StyledTableCell>
                          <StyledTableCell align="">Employment Sub Type</StyledTableCell>
                          <StyledTableCell align="" width="40%">
                            Document Required
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {mapDocumentData &&
                          mapDocumentData.map((item, mapDocumentIndex) => (
                            <StyledTableRow key={`mapallDoc_${mapDocumentIndex}`}>
                              <StyledTableCell>
                                {item?.loanType?.loanType?.parentLoanName}
                              </StyledTableCell>
                              <StyledTableCell>{item?.loanType?.loanName}</StyledTableCell>
                              <StyledTableCell>
                                {item?.employment?.employmentType?.employmentCategoryName}
                              </StyledTableCell>
                              <StyledTableCell>
                                {item?.employment?.employmentSubcategoryName}
                              </StyledTableCell>
                              <StyledTableCell>
                                <Stack direction="row" spacing={1}>
                                  {item?.documentRequired?.slice(0, 2).map((chipItemx, index) => (
                                    <Chip
                                      key={index}
                                      label={chipItemx.journeyDocumentMasterEntity.documentName}
                                      size="small"
                                    />
                                  ))}

                                  <IconButton
                                    sx={{ padding: '0.25rem' }}
                                    size="small"
                                    variant="subtitle2"
                                    className={`${mapDocumentIndex === 0 ? 'clickedElement' : ''}`}
                                    onClick={() =>
                                      openCloseChipPopUp('documentType', 'open', mapDocumentIndex)
                                    }
                                  >
                                    <MdOutlineMoreHoriz size={16} />
                                  </IconButton>
                                  <Tooltip title="Edit" placement="top" arrow>
                                    <StyledIconButton
                                      className="actionButton squareIconButton"
                                      onClick={(e) => {
                                        openCloseChipPopUp('documentPopup', '', mapDocumentIndex);
                                      }}
                                    >
                                      <BiSearch size={14} />
                                    </StyledIconButton>
                                  </Tooltip>
                                </Stack>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {popupDocumentData?.indexNo !== null && (
                  <Dialog fullWidth className="PopupBox" open={cardEdit}>
                    <DialogTitle className="popupTitle">
                      <Typography variant="h6">Select Document</Typography>
                      <IconButton onClick={(e) => setCardEdit(false)} size="small">
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      <FormGroup row>
                        {popupDocumentData?.clickedPopUpData?.map((docItem, docIndex) => (
                          <FormControlLabel
                            key={`${docItem?.journeyDocumentMasterEntity?.documentName}_${docItem.documentId}`}
                            control={
                              <Checkbox
                                onChange={(e) =>
                                  handleChangeloantype(
                                    e,
                                    docItem,
                                    'documentRequired',
                                    popupDocumentData?.indexNo,
                                    docIndex
                                  )
                                }
                                checked={docItem.mappIsActive}
                              />
                            }
                            label={docItem?.journeyDocumentMasterEntity?.documentName}
                          />
                        ))}
                      </FormGroup>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={(e) => setCardEdit(false)}
                        variant="contained"
                        className="mainBtn"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>
                )}

                {mapDocumentData &&
                  mapDocumentData.map((mapItemDoc, chippopIndexx) => (
                    <Dialog
                      key={`mapchippop_${chippopIndexx}`}
                      className={`${
                        chippopIndexx === 0 ? 'PopupBox clickedElementpop' : 'PopupBox'
                      }`}
                      open={mapItemDoc.documentChipPopUp}
                      onClick={() => openCloseChipPopUp('documentType', 'close', mapIndexchippopup)}
                      fullWidth
                    >
                      <DialogTitle className="popupTitle">
                        <Typography variant="h6">Document List</Typography>
                        <IconButton
                          onClick={() =>
                            openCloseChipPopUp('documentType', 'close', mapIndexchippopup)
                          }
                          size="small"
                        >
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent dividers>
                        <Stack direction="row" sx={{ flexWrap: 'wrap' }} spacing={1}>
                          {mapItemDoc?.documentRequired?.map((mapSubItemDoc, index) => (
                            <Chip
                              style={{ margin: '0 10px 10px 0' }}
                              key={index}
                              label={mapSubItemDoc?.journeyDocumentMasterEntity?.documentName}
                              size="small"
                            />
                          ))}
                        </Stack>
                      </DialogContent>
                    </Dialog>
                  ))}
              </Box>
              <Box className="" textAlign="right">
                <Button
                  variant="contained"
                  className="mainBtn"
                  onClick={(e) => loantyprapiFire('submitFormData', '')}
                >
                  Submit
                </Button>
              </Box>
            </>
          ) : (
            ''
          )}
        </Box>

        <Dialog
          open={errorStateData.errorPopUp}
          onClose={closePopUp}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {errorStateData.errorMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closePopUp}>Retry</Button>
          </DialogActions>
        </Dialog>

        <Loader openLoader={openLoader} />
      </Container>
    </Page>
  );
}

export default JourneyConfigureLanding;
